var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52045 16.2775C4.59212 14.5894 6.57365 13.9833 9.99943 13.9833L10.2303 13.9842C13.5296 14.0109 15.4194 14.6206 15.4797 16.2775C17.1531 14.7753 18.2057 12.5953 18.2057 10.1695C18.2057 5.63766 14.5319 1.96387 10.0001 1.96387C5.46822 1.96387 1.79443 5.63766 1.79443 10.1695C1.79443 12.5953 2.84705 14.7752 4.52045 16.2775ZM19.8307 10.1695C19.8307 15.5988 15.4294 20.0001 10.0001 20.0001C4.57076 20.0001 0.169434 15.5988 0.169434 10.1695C0.169434 4.74019 4.57076 0.338867 10.0001 0.338867C15.4294 0.338867 19.8307 4.74019 19.8307 10.1695ZM13.7071 9.4053C13.7071 7.49467 12.0558 5.96033 9.99943 5.96033C7.94314 5.96033 6.29248 7.49457 6.29248 9.4053C6.29248 11.3166 7.94301 12.851 9.99943 12.851C12.0559 12.851 13.7071 11.3165 13.7071 9.4053Z",
    fill: "#8C99B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/user-logo.ae9ff52c591720e81f2b1019e6d353f3.svg";
export { ForwardRef as ReactComponent };